import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoPrimaNotaStep2Component } from './conservazione-carica-documento-prima-nota-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-prima-nota-step2', {
            url: '/conservazione-carica-prima-nota',
            ncyBreadcrumb: {
                label: 'Carica Prima Nota',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-prima-nota-step2 flex="100"></conservazione-carica-documento-prima-nota-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoPrimaNotaStep2Module: string = ng
    .module('conservazione-carica-documento-prima-nota-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoPrimaNotaStep2', ConservazioneCaricaDocumentoPrimaNotaStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-prima-nota-step2/conservazione-carica-documento-prima-nota-step2.module.ts